// CarriageCabinSelect.tsx
import React, { useMemo, useState, useEffect } from 'react';

type Cabin = {
  _id: string;
  cabinId: string;
  carriageCode: string;
  carriageLetter: string;
  icons: any[];
  type: string;
};

const CABINS: Cabin[] = [
  {
    _id: '68ae2ddb680569c21a5197af',
    cabinId: 'A1',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197b0',
    cabinId: 'A2',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197b3',
    cabinId: 'C3',
    carriageCode: 'VLS 141 C',
    carriageLetter: 'C',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b8',
    cabinId: 'D4',
    carriageCode: 'VLS 157 D',
    carriageLetter: 'D',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197c6',
    cabinId: 'B1',
    carriageCode: 'VLS 161 B',
    carriageLetter: 'B',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b2',
    cabinId: 'C2',
    carriageCode: 'VLS 141 C',
    carriageLetter: 'C',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b7',
    cabinId: 'D3',
    carriageCode: 'VLS 157 D',
    carriageLetter: 'D',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197ba',
    cabinId: 'F2',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197bb',
    cabinId: 'A3',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197bc',
    cabinId: 'F3',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197c2',
    cabinId: 'BAR',
    carriageCode: 'VB 805',
    carriageLetter: 'BAR',
    icons: [],
    type: 'Bar',
  },
  {
    _id: '68ae2ddb680569c21a5197b1',
    cabinId: 'C1',
    carriageCode: 'VLS 141 C',
    carriageLetter: 'C',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b4',
    cabinId: 'C4',
    carriageCode: 'VLS 141 C',
    carriageLetter: 'C',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b6',
    cabinId: 'D2',
    carriageCode: 'VLS 157 D',
    carriageLetter: 'D',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197bd',
    cabinId: 'F4',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197c0',
    cabinId: 'STAFF',
    carriageCode: 'VST 326',
    carriageLetter: 'STAFF',
    icons: [],
    type: 'Staff',
  },
  {
    _id: '68ae2ddb680569c21a5197c5',
    cabinId: 'A6',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197b5',
    cabinId: 'D1',
    carriageCode: 'VLS 157 D',
    carriageLetter: 'D',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197b9',
    cabinId: 'F1',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197be',
    cabinId: 'F5',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197bf',
    cabinId: 'F6',
    carriageCode: 'VLL 767 F',
    carriageLetter: 'F',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197c1',
    cabinId: 'RESTAURANT',
    carriageCode: 'VR 782',
    carriageLetter: 'RESTAURANT',
    icons: [],
    type: 'Restaurant',
  },
  {
    _id: '68ae2ddb680569c21a5197c9',
    cabinId: 'B4',
    carriageCode: 'VLS 161 B',
    carriageLetter: 'B',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197c4',
    cabinId: 'A5',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
  {
    _id: '68ae2ddb680569c21a5197c8',
    cabinId: 'B3',
    carriageCode: 'VLS 161 B',
    carriageLetter: 'B',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197c7',
    cabinId: 'B2',
    carriageCode: 'VLS 161 B',
    carriageLetter: 'B',
    icons: [],
    type: 'Suite',
  },
  {
    _id: '68ae2ddb680569c21a5197c3',
    cabinId: 'A4',
    carriageCode: 'VLL 619 A',
    carriageLetter: 'A',
    icons: [],
    type: 'Deluxe',
  },
];

type CarriageCabinSelectProps = {
  value?: string; // e.g. 'A6'
  onChange?: (value: string) => void;
};

const CarriageCabinSelect: React.FC<CarriageCabinSelectProps> = ({ value = '', onChange }) => {
  const carriages = useMemo(() => {
    const set = new Set<string>();
    CABINS.forEach((cabin) => {
      if (cabin.carriageLetter.length === 1) {
        set.add(cabin.carriageLetter);
      }
    });
    return Array.from(set).sort();
  }, []);

  const [selectedCarriage, setSelectedCarriage] = useState<string>('');
  const [selectedCabinLocal, setSelectedCabinLocal] = useState<string>('');

  // Sync local state with parent value / carriages
  useEffect(() => {
    if (value) {
      setSelectedCabinLocal(value);
      const carriageLetter = value[0];
      if (carriages.includes(carriageLetter)) {
        setSelectedCarriage(carriageLetter);
      }
    } else if (!selectedCarriage && carriages.length) {
      setSelectedCarriage(carriages[0]);
      setSelectedCabinLocal('');
    }
  }, [value, carriages, selectedCarriage]);

  const availableCabins = useMemo(() => {
    if (!selectedCarriage) return [];
    return CABINS
      .filter(
        (c) =>
          c.carriageLetter === selectedCarriage &&
          c.carriageLetter.length === 1,
      )
      .sort((a, b) => a.cabinId.localeCompare(b.cabinId));
  }, [selectedCarriage]);

  const handleCarriageChange = (carriage: string) => {
    setSelectedCarriage(carriage);
    setSelectedCabinLocal('');
    if (onChange) onChange('');
  };

  const handleCabinChange = (cabinId: string) => {
    setSelectedCabinLocal(cabinId);
    if (onChange) onChange(cabinId);
  };

  return (
    <div className='flex flex-col gap-3 md:flex-row md:items-end'>
      {/* Carriage Select */}
      <div className='flex-1'>
        <label className='text-sm opacity-80 dark:text-white'>Carriage</label>
        <select
          className='mt-1 border rounded px-2 py-1 w-full bg-white dark:bg-black dark:text-white'
          value={selectedCarriage}
          onChange={(e) => handleCarriageChange(e.target.value)}
        >
          <option value=''>Select carriage</option>
          {carriages.map((carriage) => (
            <option key={carriage} value={carriage}>
              {carriage}
            </option>
          ))}
        </select>
      </div>

      {/* Cabin Select */}
      <div className='flex-1'>
        <label className='text-sm opacity-80 dark:text-white'>Cabin</label>
        <select
          className='mt-1 border rounded px-2 py-1 w-full bg-white dark:bg-black dark:text-white disabled:bg-gray-100 dark:disabled:bg-zinc-900 disabled:text-gray-500'
          value={selectedCabinLocal}
          onChange={(e) => handleCabinChange(e.target.value)}
          disabled={!selectedCarriage}
        >
          <option value=''>
            {selectedCarriage ? 'Select cabin' : 'Choose carriage first'}
          </option>
          {availableCabins.map((cabin) => {
            const cabinNumber = cabin.cabinId.replace(/^\D+/, '');
            return (
              <option key={cabin._id} value={cabin.cabinId}>
                {cabinNumber} ({cabin.cabinId})
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default CarriageCabinSelect;
